import { t, Trans } from '@lingui/macro'
import { useRoomOptions } from 'context'
import { navigate } from 'helpers'
import { useEffect } from 'react'
import { Button, FlexAlignItemsCenter, Loading } from 'webbook-airways'
import { Select } from './Select'

export default function InputFieldRooms({
  disabled,
  value,
  onChange,
  required,
  withoutAll,
  room_group_id,
  loc,
  noBorder = true,
  filter_rooms,
}) {
  const { loading, rooms, setLocation, setGroup } = useRoomOptions()

  useEffect(() => {
    if (
      typeof room_group_id === 'undefined' ||
      typeof room_group_id === 'string'
    ) {
      setGroup(room_group_id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [room_group_id])

  useEffect(() => {
    if (typeof loc === 'undefined' || typeof loc === 'string') {
      setLocation(loc)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc])

  useEffect(() => {
    if (filter_rooms && filter_rooms?.length > 0) {
      rooms.filter((room) => {
        let result = true
        filter_rooms.forEach((f) => {
          if (f.room_id === room.room_id) {
            result = false
          }
        })
        return result
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter_rooms])

  if (loading) {
    return (
      <FlexAlignItemsCenter css={{ justifyContent: 'center', minWidth: 100 }}>
        <Loading size={20} container={false} noTimeout />
      </FlexAlignItemsCenter>
    )
  }

  if (rooms?.length < 1) {
    return (
      <Button
        onClick={() => navigate('/booking/setup/rooms/1')}
        variant="outlined"
        style={{ margin: 5, width: '100%' }}
      >
        <Trans>No rooms found, create at least one</Trans>
      </Button>
    )
  }

  return (
    <Select
      value={value ? `${value}` : undefined}
      onChange={onChange}
      options={rooms.map((room) => ({
        value: `${room.room_id}`,
        label: room.name,
      }))}
      label={t`Room`}
      required={required}
      placeholder={t`Choose room`}
      noBorder={noBorder}
      disabled={disabled}
      withoutAll={withoutAll}
    />
  )
}
